import { UniInputVariant } from '@/design-system/components/inputs/useInputTheme.hook';
import { GetUserResponse, GetWalletsByAssetResponse } from '@utx/utx-client';
import create from 'zustand';
import { BaseCurrency, Vendor } from './types';

export interface Store {
  authToken: string;
  baseCurrency: BaseCurrency;
  brand: string;
  inputVariant: UniInputVariant;
  locale: string;
  loggedIn: boolean;
  showAmount: boolean;
  theme: 'light' | 'dark';
  users: GetUserResponse | null;
  vendor: Vendor | null;
  wallets: Array<GetWalletsByAssetResponse>;
  offerCategories: Array<string>;
  lastMoved: Date;
  userFeatures: { [feature: string]: string };
  changeAuthToken: (authToken: string) => void;
  changeBaseCurrency: (baseCurrency: BaseCurrency) => void;
  changeBrand: (brand: string) => void;
  changeInputVariant: (inputVariant: UniInputVariant) => void;
  changeLocale: (locale: string) => void;
  changeLoggedIn: (value: boolean) => void;
  changeOfferCategories: (categories: Array<string>) => void;
  changeShowAmount: (showAmount: boolean) => void;
  changeTheme: (theme: 'light' | 'dark') => void;
  changeUsers: (users: GetUserResponse) => void;
  changeVendor: (vendor: Vendor) => void;
  changeWallets: (wallets: Array<GetWalletsByAssetResponse>) => void;
  toggleTheme: () => void;
  changeUserFeatures: (userFeatures: { [feature: string]: string }) => void;
}

export const useStore = create<Store>((set) => ({
  authToken: '',
  baseCurrency: BaseCurrency.USD,
  brand: 'UTGL',
  inputVariant: UniInputVariant.v1,
  locale: 'en-US',
  loggedIn: false,
  showAmount: true,
  theme: 'light',
  users: null,
  vendor: null,
  wallets: [],
  offerCategories: [],
  lastMoved: new Date(),
  userFeatures: {},
  changeAuthToken: (authToken: string) => set((state) => ({ ...state, authToken })),
  changeBaseCurrency: (baseCurrency: BaseCurrency) => set((state) => ({ ...state, baseCurrency })),
  changeBrand: (brand) => set((state) => ({ ...state, brand })),
  changeInputVariant: (inputVariant: UniInputVariant) => set((state) => ({ ...state, inputVariant })),
  changeLocale: (locale: string) => set((state) => ({ ...state, locale })),
  changeLoggedIn: (value: boolean) => set((state) => ({ ...state, loggedIn: value })),
  changeOfferCategories: (categories: Array<string>) => set((state) => ({ ...state, offerCategories: categories })),
  changeShowAmount: (showAmount: boolean) => set((state) => ({ ...state, showAmount })),
  changeTheme: (theme: 'light' | 'dark') => set((state) => ({ ...state, theme })),
  changeUsers: (users: GetUserResponse) => set((state) => ({ ...state, users })),
  changeVendor: (vendor: Vendor) => set((state) => ({ ...state, vendor })),
  changeWallets: (wallets: Array<GetWalletsByAssetResponse>) => set((state) => ({ ...state, wallets })),
  toggleTheme: () => set((state) => ({ ...state, theme: state.theme === 'light' ? 'dark' : 'light' })),
  changeUserFeatures: (userFeatures: { [feature: string]: string }) => set((state) => ({ ...state, userFeatures }))
}));
